const paymentMethods = {
  creditCard: 'creditCard',
  payPal: 'payPal',
  applePay: 'applePay',
}


export default paymentMethods
